var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new-folder--empty-folder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.35693 21.0001V3.00018C1.35693 2.54551 1.53755 2.10948 1.85904 1.78799C2.18053 1.4665 2.61656 1.28588 3.07122 1.28588H9.39693C9.78853 1.27448 10.1722 1.39754 10.4842 1.63459C10.796 1.87164 11.0174 2.20838 11.1112 2.58875L11.6426 4.71446H21.9284C22.383 4.71446 22.8191 4.89506 23.1405 5.21656C23.462 5.53806 23.6426 5.97408 23.6426 6.42875V21.0001C23.6426 21.4549 23.462 21.8908 23.1405 22.2123C22.8191 22.5339 22.383 22.7144 21.9284 22.7144H3.07122C2.61656 22.7144 2.18053 22.5339 1.85904 22.2123C1.53755 21.8908 1.35693 21.4549 1.35693 21.0001Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    stroke: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.c42d7923c2e13a18e631f85b4068e419.svg";
export { ForwardRef as ReactComponent };